import React, { Fragment } from 'react';
import { Link } from 'gatsby';

// @ts-ignore
import styles from './ArticlesList.module.scss';

export const hasSlug = object => object && object.slug;
export default ({ subCategories, slug, stylesProp }) => {
  const articleClass = stylesProp && stylesProp.article ? stylesProp.article : styles.article;
  return (
    <>
      {subCategories &&
        subCategories.map(subCategory => (
          <Fragment key={subCategory.id}>
            {subCategory.displayName && <h3>{subCategory.displayName}</h3>}
            <ul className={`${styles.articleList} ${(stylesProp && stylesProp.articleList) || ''}`}>
              {subCategory.helpArticles.filter(hasSlug).map(article => (
                <li key={article.slug}>
                  <Link to={`/${slug}/${article.slug}`} className={articleClass}>
                    {article.question}
                  </Link>
                </li>
              ))}
            </ul>
          </Fragment>
        ))}
    </>
  );
};
